import { Tooltip } from "antd";
import React from "react";

const HelpTooltip = ({ text, color = "black", imageSrc }) => {
  return (
    <Tooltip
      title={
        imageSrc ? (
          <img
            src={imageSrc}
            alt="help"
            style={{
              maxWidth: "480px",
              maxHeight: "380px",
              objectFit: "contain",
              borderRadius: "6px",
              display: "block",
            }}
          />
        ) : (
          <span style={{ fontSize: "13px", lineHeight: "1.5" }}>{text}</span>
        )
      }
      overlayInnerStyle={{
        maxWidth: imageSrc ? "500px" : "280px",
        padding: imageSrc ? "6px" : "8px 12px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      }}
      mouseEnterDelay={0.1}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "17px",
          height: "17px",
          borderRadius: "50%",
          background: "transparent",
          border: `2px solid ${color}`,
          cursor: "default",
          flexShrink: 0,
          transition: "opacity 0.15s",
          opacity: 0.75,
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.75")}
      >
        <span
          style={{
            color,
            fontSize: "11px",
            fontWeight: "800",
            lineHeight: 1,
            userSelect: "none",
          }}
        >
          ?
        </span>
      </div>
    </Tooltip>
  );
};

export default HelpTooltip;
